<template>
  <div class="print-template">
    <!-- 4单个业务-含检测报告及配件费明细-->
    <div id="part1">
      <h3 style="text-align:center;font-size:20px;font-weight:bold">{{printDetail.titleDetail.name}}</h3>
      <h3 style="text-align:center;font-size:20px;font-weight:bold">维修报价单</h3>
      <div style="display:flex;width:100%" v-if="printDetail.details && printDetail.details.length">
        <el-descriptions :column="1" style="width:49.5%">
          <el-descriptions-item label="TO 收件人：">{{printDetail.customerCompanyContactDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="E-mail 电邮：">{{printDetail.receivingEmail}}</el-descriptions-item>
          <el-descriptions-item label="Company 公司：">{{printDetail.customerCompanyDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="Tel 电话：">{{printDetail.customerCompanyContactDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="Project 报价项目：">{{printDetail.details[0].businessName}}</el-descriptions-item>
          <el-descriptions-item label="Model 型号：">{{printDetail.details[0].businessModel}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1">
          <el-descriptions-item label="Quote From 报价人：">{{printDetail.salesManDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="Tel 电话：">{{printDetail.salesManDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="Line 座机：">{{printDetail.titleDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="E-Mail 电邮：">{{printDetail.salesManDetail.email}}</el-descriptions-item>
          <el-descriptions-item label="Date 日期：">{{new Date().toLocaleDateString().replace(/\//g, '-')}}</el-descriptions-item>
          <el-descriptions-item label="Quote No.业务编号：">{{printDetail.details[0].businessNo}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <h4 class="form-title">工作描述：</h4>
      <div class="table-descri" >
        <div class="table-descri-li">
          <span class="table-descri-lable">设备故障现象</span>
          <span class="table-descri-content">{{printDetail.fault}}</span>
        </div>
        <div class="table-descri-li">
          <span class="table-descri-lable">初步检测情况</span>
          <span class="table-descri-content">{{printDetail.checkDes}}</span>
        </div>
        <div class="table-descri-li">
          <span class="table-descri-lable">损坏元件</span>
          <span class="table-descri-content">{{printDetail.changeParts}}</span>
        </div>
      </div>
      <h4 class="form-title">维修费用：</h4>
    </div>
    <vxe-table
      border
      show-footer
      ref="xTable"
      align="center"
      :print-config="tablePrint"
      keep-source
      auto-resize
      :column-config="{ resizable: true }"
      :merge-cells="mergeCells"
      :merge-footer-items="mergeFooterItems"
      :data="tableData"
      >
      <vxe-column field="a" title="项目内容" min-width="120" />
      <vxe-column field="name" title="名称" min-width="120" />
      <vxe-column field="amount" title="数量" width="60" />
      <vxe-column field="unitPrice" title="单价(RNB)" width="90" />
      <vxe-column field="totalPrice" title="总价(RNB)" width="90" />
      <vxe-column field="mark" title="备注" min-width="100" />
    </vxe-table>
    <div id="part2">
      <h4 class="form-title">备注：</h4>
      <pre>{{printDetail.quotationMarkTemplateDetail.mark}} </pre>
      <div style="display:flex;width:100%;margin-top:100px;">
        <div style="width:49%">
          客户代表方签字：<span class="sign-container-border" />
        </div>
        <div style="position:relative">
          业务签字：<span class="sign-container-border" />
          <ZPreview :authSrc="printDetail.titleDetail.sealImg" width="100px" height="100px" class="upload-file_preview" />
        </div>
      </div>
    </div>
  </div>
</template>
<script  lang="ts">
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import ZPreview from '@/components/common/ZPreview.vue'
import { descriptionStyle, signContainer } from '@/utils/print'
import mixin from './mixin'

export default defineComponent({
  components: {
    ZPreview
  },
  props: {
    detail: { type: Object, required: true, default: () => null }
  },
  setup(props) {
    const dataMap = reactive({
      tableData: [] as any[],
      printStyle: descriptionStyle + signContainer
    })
    const printMixin = mixin(props, dataMap)

    const handleMerge = () => {
      // 根据行数据计算合并规则
      const mergeCells = [
        { row: 0, col: 0, rowspan: dataMap.tableData.length - 3, colspan: 1 },
        { row: 0, col: 5, rowspan: dataMap.tableData.length, colspan: 1 },
        { row: dataMap.tableData.length - 1, col: 0, rowspan: 1, colspan: 4 },
        { row: dataMap.tableData.length - 2, col: 0, rowspan: 1, colspan: 2 },
        { row: dataMap.tableData.length - 3, col: 0, rowspan: 1, colspan: 2 }
      ]

      // 根据行数据计算表尾合并规则
      const mergeFooterItems = [
        { row: 0, col: 0, rowspan: 1, colspan: 4 }
      ]
      printMixin.mergeCells = mergeCells
      printMixin.mergeFooterItems = mergeFooterItems
    }

    onMounted(() => {
      const partsData = printMixin.printDetail.parts.map((item: any) => {
        return {
          ...item,
          mark: printMixin.getTaxRateLabel(props.detail.taxRate),
          a: '配件费'
        }
      })
      if (!Array.isArray(printMixin.printDetail.fee)) {
        printMixin.printDetail.fee = [printMixin.printDetail.fee]
      }
      const feeData = printMixin.printDetail.fee.map((item: any) => {
        return {
          ...item,
          unitPrice: printMixin.numberPlus(item.unitPrice, 0, true),
          a: '维修费',
          totalPrice: printMixin.numberTimes(item.unitPrice, item.amount, true)
        }
      })
      const footerData = [
        ...feeData,
        { a: '税金', amount: '13%' },
        { a: '总计(RNB)', totalPrice: printMixin.sumTotalNum([...partsData, ...feeData], 'unitPrice', 'amount') }
      ]
      dataMap.tableData = [...partsData, ...footerData]
      handleMerge()
    })
    return {
      ...printMixin,
      ...toRefs(dataMap)
    }
  }
})
</script>
<style lang="scss">
.print-template{
  .table-descri{
    .is-bordered-label{
      width: 180px;
      background: #fff;
    }
  }
  .sign-container-border{
    border: 1px solid rgba(0,0,0,.7);
    height: 0px;
    width: 200px;
    display: inline-block;
  }
  .upload-file_preview{
    position: absolute;
    top: -45px;
    left: 130px;
  }
  pre {
    white-space: pre-wrap;
    word-break: break-all;
    max-width: 100%;
    font-family: inherit;
  }
  #part1, #part2 {
    max-width: 100%;
  }
}

</style>
